document.addEventListener('DOMContentLoaded', () => {

    const tabs = [
        ...document.querySelectorAll('.single-formation-tabs__button')
    ];

    const contents = [
        ...document.querySelectorAll('.single-formation-tabs__content')
    ];

    if (!tabs.length || !contents.length) {
        return;
    }

    const mobileTitle = document.querySelector('.single-formation-tabs__mobile-title');
    const prevBtn = document.querySelector('.single-formation-tabs__mobile-prev');
    const nextBtn = document.querySelector('.single-formation-tabs__mobile-next');

    let currentIndex = tabs.findIndex(tab =>
        tab.classList.contains('is-active')
    );

    if (currentIndex < 0) {
        currentIndex = 0;
    }

    function activateTab(index) {

        tabs.forEach(tab => tab.classList.remove('is-active'));
        contents.forEach(content => content.classList.remove('is-active'));

        tabs[index].classList.add('is-active');
        contents[index].classList.add('is-active');

        currentIndex = index;

        if (mobileTitle) {
            mobileTitle.textContent = tabs[index].textContent.trim();
        }
    }

    tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
            activateTab(index);
        });
    });

    if (prevBtn) {
        prevBtn.addEventListener('click', () => {

            currentIndex =
                (currentIndex - 1 + tabs.length) % tabs.length;

            activateTab(currentIndex);
        });
    }

    if (nextBtn) {
        nextBtn.addEventListener('click', () => {

            currentIndex =
                (currentIndex + 1) % tabs.length;

            activateTab(currentIndex);
        });
    }

    activateTab(currentIndex);

});